export default __webpack_public_path__ + "static/media/ic_frax_40.248a3971.svg";